// Components
import rootStyles from '../../pages/puppy/[id].module.scss'
import styles from './Parents.module.scss'
import Image from 'next/legacy/image'
// Utils
import { convertToKG } from '../../components/weightInput'
import Title from '../Title'

export default function Parents({ dog }) {
  const Card = ({ kinship }) => {
    const parent = dog.litter[kinship]
    const registrations =
      parent?.registrations?.split(',').filter((r) => !!r) || []

    return (
      <div className={styles.card}>
        <div className={styles.imageContainer}>
          <div className={styles.image}>
            <Image
              width={350}
              height={350}
              src={
                parent?.profilePicture
                  ? `${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${parent?.profilePicture.medium}`
                  : '/placeholder-dog.svg'
              }
              alt="dog"
            />
          </div>
        </div>

        <div className={styles.header}>
          <div className={styles.name}>{parent?.name}</div>

          <div className={styles.kinship}>{kinship}</div>
        </div>

        <div className={styles.breed}>{parent?.breed?.name}</div>

        {!!parent?.weight && (
          <div className={styles.weight}>
            Weight{' '}
            {dog.currency === 'USD'
              ? `${parent?.weight} lb`
              : `${convertToKG(parent?.weight)} kg`}
          </div>
        )}

        {!!registrations.length && registrations[0] !== 'N/A' && (
          <div className={styles.registration}>
            <img src="/puppy/check-mark.svg" alt="check mark" />

            <div className={styles.code}>
              {`${registrations[0]} Registered`}
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={rootStyles.section}>
      <Title variant="h2"> {dog?.name}'s Parents</Title>

      <div className={styles.cardsContainer}>
        {!!dog?.litter?.mom && <Card kinship="mom" />}

        {!!dog?.litter?.dad && <Card kinship="dad" />}
      </div>
    </div>
  )
}
